import { render, staticRenderFns } from "./orderHistoryList.vue?vue&type=template&id=1cb231c8&"
import script from "./orderHistoryList.vue?vue&type=script&lang=js&"
export * from "./orderHistoryList.vue?vue&type=script&lang=js&"
import style0 from "./orderHistoryList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports